// Spalten der Kontakte-Liste (C01, C02), rein und ohne React (mit node --test prüfbar, deshalb nur Typ-Importe).
import type { ListenSortierung, ListenSpalte } from "../components/smartview/listenVertrag";

/** Schlüssel der Symbolspalte (Telefon und E-Mail), wie in den Lead-Listen. */
export const KONTAKTWEGE = "kontaktwege";

export const KONTAKT_SPALTEN: ListenSpalte[] = [
  { key: "name", label: "Name", gruppe: "Kontakt", sortierbar: true, fest: true },
  { key: KONTAKTWEGE, label: "Telefon und E-Mail (Symbole)", gruppe: "Kontakt" },
  { key: "title", label: "Funktion", gruppe: "Kontakt", sortierbar: true },
  { key: "telefon", label: "Telefonnummer", gruppe: "Kontakt" },
  { key: "email", label: "E-Mail-Adresse", gruppe: "Kontakt" },
  { key: "lead", label: "Lead", gruppe: "Lead", sortierbar: true },
  { key: "status", label: "Lead-Status", gruppe: "Lead" },
  { key: "date_created", label: "Erstellt", gruppe: "Kontakt", sortierbar: true },
  { key: "date_updated", label: "Geändert", gruppe: "Kontakt", sortierbar: true },
];

/** Wie in Close: Name, Symbole, Funktion, Lead; dazu der Lead-Status. */
export const KONTAKT_STANDARD = ["name", KONTAKTWEGE, "title", "lead", "status"];

export const KONTAKT_STANDARD_SORT: ListenSortierung = { key: "name", ab: false };

/** Spaltenschlüssel -> `sort` der Route. */
export const KONTAKT_SORT_FELD: Readonly<Record<string, string>> = {
  name: "name",
  title: "title",
  lead: "lead",
  date_created: "date_created",
  date_updated: "date_updated",
};

/** Daten beginnen mit dem Neuesten, Namen mit A. */
export function ersteRichtungAb(key: string): boolean {
  return key.startsWith("date");
}

export function kontaktName(name: string | null | undefined, phones: { phone: string }[], emails: { email: string }[]): { text: string; ohneName: boolean } {
  const n = (name ?? "").trim();
  if (n) return { text: n, ohneName: false };
  const ersatz = phones[0]?.phone || emails[0]?.email;
  return { text: ersatz ?? "Ohne Namen", ohneName: true };
}
